/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { TagValueTypeFromJSON, TagValueTypeToJSON, } from './';
export function TagRequestFromJSON(json) {
    return TagRequestFromJSONTyped(json, false);
}
export function TagRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !exists(json, 'name') ? undefined : json['name'],
        'valueType': TagValueTypeFromJSON(json['valueType']),
        'predefinedValuesOnly': json['predefinedValuesOnly'],
        'predefinedValues': !exists(json, 'predefinedValues') ? undefined : json['predefinedValues']
    };
}
export function TagRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'valueType': TagValueTypeToJSON(value.valueType),
        'predefinedValuesOnly': value.predefinedValuesOnly,
        'predefinedValues': value.predefinedValues
    };
}
